import React from 'react';
import DetailPage from './DetailPage';
import DetailPageHero from './DetailPageHero';
import DetailPageHeroVideo from './DetailPageHeroVideo';
import DetailPageBanner from './DetailPageBanner';
import DetailPageHeroYouTube from './DetailPageHeroYouTube';
import DetailPageParagraph from './DetailPageParagraph';

const DetailPageMacOSReality = () => {
  return (
    <DetailPage 
      title="The Next Generation of AR Operating Systems"
      heroSrc={'/images/macos-reality/header.png'}
      content="For almost 50 years, the concept of computers has largely remained the same. We are staring at an operating system on a 2D screen that is controlled via a mouse and keyboard. However, with AR technology and specifically the advent of AR glasses wearables, there exists the opportunity to fundamentally disrupt and redefine the way we interact with a computer."
      year="2020"
      intent="Solo Passion Project"
      duration="3 months"
    >

        <DetailPageBanner 
            header="The Bottom Line" 
            content="This project went viral and received media presence in 20+ countries. It was featured on popular Apple news websites including iMore (~15 million monthly visitors) and CultOfMac (~1 million monthly visitors) in an article. MacRumors (~1 million followers on Twitter; 12 million monthly web page visitors) featured this concept in a tweet."
            lastWord="Released 4 years prior to Apple Vision Pro, a lot of the predictions in this concept ended up being true. This has been a key project in my own journey to not only get hired by Apple but also contribute to the future of Apple Vision at the company."/>

        <DetailPageHeroYouTube
            videoId="xKXLk76TkEc"
            lazy={true}
        />
        
        <DetailPageHero
            src="/images/macos-reality/hero2.png"
            title="A spatial operating system for powerful productivity in 3D space intended for Augmented Reality & Mixed Reality."
            adaptiveAspectRatio
        />

        <DetailPageParagraph>
          macOS reality defines a new era of productivity through sophisticated use of Augmented Reality, making optimal use of your physical environment to keep you more productive through unlimited screen space.
        </DetailPageParagraph>

        <DetailPageHeroVideo
            src="/videos/macos-reality/hero.mp4"
            poster="/path/to/thumbnail.jpg"
            lazy={true}
            autoPlay={true}
            muted={true}
            loop={true}
        />

        <DetailPageParagraph>
            Widgets placed on your desktop allow for easy access to important and useful information without requiring a lot of physical space. To reduce physical space even further, widget groups combine multiple widgets for even more efficient use of space. You can conveniently interact with widgets by poking with your index finger.
        </DetailPageParagraph>

        <DetailPageHeroVideo
            src="/videos/macos-reality/widgets.mp4"
            poster="/path/to/thumbnail.jpg"
            lazy={true}
            autoPlay={true}
            muted={true}
            loop={true}
        />

        <DetailPageParagraph>
            Desktop collections are presets of your commonly used window arrangements. With a tap of a button you can switch between collections on the fly enabling you to truly have unlimited virtual window space. The function strip above your keyboard gives access to useful quick actions based on the application that you are currently focused on.
        </DetailPageParagraph>

        <DetailPageHeroVideo
            src="/videos/macos-reality/tabletop.mp4"
            poster="/path/to/thumbnail.jpg"
            lazy={true}
            autoPlay={true}
            muted={true}
            loop={true}
        />

        <DetailPageParagraph>
            Facetime is more immersive than ever before. Even when you are not physically at the same location, a 3D hologram avatar created using body scanning of your iPhone or online using just a portrait picture enables you to interact with people as if they were next to you. In addition, 3D avatars can also be used if you simply don't want to commit to showing your face on camera while still having the benefits of facial expressions and feeling closer together.
       </DetailPageParagraph>

        <DetailPageHeroVideo
            src="/videos/macos-reality/facetime.mp4"
            poster="/path/to/thumbnail.jpg"
            lazy={true}
            autoPlay={true}
            muted={true}
            loop={true}
        />

        <DetailPageParagraph>
            macOS reality allows you to freely position, change the size, and even curve any windows in 3D space, enabling you to optimally make use of your space just the way you need it to to make your workflow as efficient as possible. In combination with widgets and desktop collections, you truly always have the most important content you care about in front of your eyes.
        </DetailPageParagraph>

        <DetailPageHeroVideo
            src="/videos/macos-reality/os.mp4"
            poster="/path/to/thumbnail.jpg"
            lazy={true}
            autoPlay={true}
            muted={true}
            loop={true}
        />

        <DetailPageParagraph>
            Finder shows all your files more sophisticated than ever before. By introducing Smart Grid, an intelligent way to arrange your grid that places all folders at the top and increases the cell size of certain elements (e.g. videos) based on your usage and demands, your files are more organized than ever before. In addition, Finder now supports viewing 3D models (.fbx, .obj, .dae, etc.) with depth making it even more convenient to check out assets for the game you are developing, physical products you are designing, and more.
        </DetailPageParagraph>

        <DetailPageHeroVideo
            src="/videos/macos-reality/finder.mp4"
            poster="/path/to/thumbnail.jpg"
            lazy={true}
            autoPlay={true}
            muted={true}
            loop={true}
        />

        <DetailPageHeroVideo
            src="/videos/macos-reality/allapps.mp4"
            poster="/path/to/thumbnail.jpg"
            lazy={true}
            autoPlay={true}
            muted={true}
            loop={true}
        />

        <DetailPageParagraph>
            Safari lives on in 3D and it is more powerful than ever. Now you have enough real estate to view multiple websites next to each other, resize them however you imagine and make it more convenient to browse through curved windows. In addition to your virtual trackpad or a traditional mouse, you can use your hands as an input device to scroll through your favorite pages. Lastly, Safari in macOS reality now supports more sophisticated true AR experiences that you can directly view through your glasses.
        </DetailPageParagraph>

        <DetailPageHeroVideo
            src="/videos/macos-reality/safari.mp4"
            poster="/path/to/thumbnail.jpg"
            lazy={true}
            autoPlay={true}
            muted={true}
            loop={true}
        />

        <DetailPageParagraph>
            macOS reality allows you to freely position, change the size, and even curve any windows in 3D space, enabling you to optimally make use of your space just the way you need it to to make your workflow as efficient as possible. In combination with widgets and desktop collections, you truly always have the most important content you care about in front of your eyes.
        </DetailPageParagraph>

        <DetailPageHeroVideo
            src="/videos/macos-reality/multitask.mp4"
            poster="/path/to/thumbnail.jpg"
            lazy={true}
            autoPlay={true}
            muted={true}
            loop={true}
        />

        <DetailPageParagraph>
            macOS reality offers wide ranging options for input that have many use cases in mind. From physical accessories to more portable virtual UI as well as mid-air hand input to less fatiguing rested hand input, you can choose how to be productive in the most comfortable way possible. For keyboard input, you can choose between a physical keyboard accessory or a virtual keyboard that can be mapped onto a flat surface for natural haptic feedback.
        </DetailPageParagraph>

        <DetailPageHeroVideo
            src="/videos/macos-reality/intro.mp4"
            poster="/path/to/thumbnail.jpg"
            lazy={true}
            autoPlay={true}
            muted={true}
            loop={true}
        />

        <DetailPageParagraph>
            Scanning your physical environment is a crucial step to make the most out of macOS reality when used at home or in the office. It enables the system to be aware of the size and location of your desk as well as any obstacles that lay around to avoid intersection with UI elements.
        </DetailPageParagraph>

        <DetailPageHeroVideo
            src="/videos/macos-reality/desk-setup.mp4"
            poster="/path/to/thumbnail.jpg"
            lazy={true}
            autoPlay={true}
            muted={true}
            loop={true}
        />
        
    </DetailPage>
  );
};

export default DetailPageMacOSReality; 